export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20cinematic%20composition%20with%20dramatic%20crimson%20and%20deep%20amber%20lighting%2C%20atmospheric%20smoke%20and%20geometric%20shapes%2C%20mysterious%20and%20bold%20editorial%20aesthetic%2C%20high%20contrast%20with%20soft%20shadow%20gradients%2C%20professional%20dark%20media%20backdrop%20with%20warm%20tonal%20accents%2C%20no%20text%20or%20faces&width=1600&height=900&seq=hero-bg-2026-hlv&orientation=landscape"
          alt="黑料视频主视觉背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-300 text-xs md:text-sm font-medium tracking-wider mb-5">
              24小时不打烊 · 持续爆料
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-[56px] font-extrabold text-white leading-tight mb-4">
              黑料视频<span className="text-primary-400"> · </span>
              <span className="text-accent-400">24小时不打烊黑料社区</span>
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading italic mb-6">
              &ldquo;体内精69xxxxx黑料社持续追踪，最新社区视频合集免费在线看&rdquo;
            </p>

            <p className="text-sm md:text-base text-white/60 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-8">
              黑料视频官网倾力打造24小时滚动更新的黑料社区平台。聚焦热门爆料、内幕追踪与社区热议话题，体内精69xxxxx黑料社持续产出独家深度内容。本站视频每日不间断更新，涵盖全网最新黑料合集与精选社区视频，无需注册即可免费在线观看。热点不断档，刷新即有新料。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-extrabold text-white font-heading">2400+</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">累计爆料视频</div>
              </div>
              <div className="w-px h-10 bg-white/15" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-extrabold text-accent-400 font-heading">24h</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">不间断更新</div>
              </div>
              <div className="w-px h-10 bg-white/15" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-extrabold text-white font-heading">50万+</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">社区活跃用户</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg" />
                立即浏览最新爆料
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 bg-white/10 hover:bg-white/20 text-white font-medium text-sm rounded-lg border border-white/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-line text-lg" />
                查看热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-xl overflow-hidden border border-white/10 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20dark%20media%20composition%20with%20glowing%20crimson%20and%20amber%20highlights%2C%20geometric%20play%20button%20shapes%20and%20dynamic%20light%20streaks%2C%20cinematic%20atmosphere%20with%20dark%20void%20background%2C%20modern%20video%20platform%20aesthetic%2C%20bold%20contrast%20with%20warm%20accent%20lighting%2C%20no%20text%20or%20people&width=1040&height=780&seq=hero-visual-2026-hlv&orientation=landscape"
                alt="黑料视频24小时更新在线看"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}